export const SET_AGENCES = 'SET_AGENCES'
